import { defaultsDeep } from 'lodash';
import { disabledSettings, options, qsOptions } from './optionsStorage';
import { miscUiState } from './globalState';
import { setLoadingScreenStatus } from './appStatus';
import { setStorageDataOnAppConfigLoad } from './react/appStorageProvider';
import { customKeymaps, updateBinds } from './controls';
import { onAppViewerConfigUpdate } from './appViewer';
let watermarkEl = null;
function dismissWatermark() {
    watermarkEl?.remove();
    watermarkEl = null;
}
function watermarkTextFromConfig(cfg) {
    const parts = [];
    const w = cfg?.watermark?.trim();
    if (w)
        parts.push(w);
    if (cfg?.watermarkDate && process.env.BUILD_DISPLAY_DATE) {
        parts.push(`BUILD ${process.env.BUILD_DISPLAY_DATE}`);
    }
    return parts.length ? parts.join('\n') : '';
}
function setWatermarkFromConfig(cfg) {
    const text = watermarkTextFromConfig(cfg);
    if (!text) {
        watermarkEl?.remove();
        watermarkEl = null;
        return;
    }
    if (!watermarkEl) {
        watermarkEl = document.createElement('div');
        watermarkEl.className = 'app-watermark';
        watermarkEl.dataset.appWatermark = '';
        watermarkEl.title = 'Click to dismiss';
        watermarkEl.addEventListener('click', dismissWatermark);
        document.body.appendChild(watermarkEl);
    }
    watermarkEl.textContent = text;
}
export const loadAppConfig = (appConfig) => {
    if (miscUiState.appConfig) {
        Object.assign(miscUiState.appConfig, appConfig);
    }
    else {
        miscUiState.appConfig = appConfig;
    }
    if (appConfig.forceSettings) {
        for (const [key, value] of Object.entries(appConfig.forceSettings)) {
            if (value) {
                disabledSettings.value.add(key);
                // since the setting is forced, we need to set it to that value
                if (appConfig.defaultSettings && key in appConfig.defaultSettings && !qsOptions[key]) {
                    options[key] = appConfig.defaultSettings[key];
                }
            }
            else {
                disabledSettings.value.delete(key);
            }
        }
    }
    // todo apply defaultSettings to defaults even if not forced in case of remote config
    if (appConfig.keybindings) {
        Object.assign(customKeymaps, defaultsDeep(appConfig.keybindings, customKeymaps));
        updateBinds(customKeymaps);
    }
    onAppViewerConfigUpdate();
    setStorageDataOnAppConfigLoad(appConfig);
    setWatermarkFromConfig(miscUiState.appConfig);
};
export const isBundledConfigUsed = !!process.env.INLINED_APP_CONFIG;
if (isBundledConfigUsed) {
    loadAppConfig(process.env.INLINED_APP_CONFIG ?? {});
}
else {
    void window.fetch('config.json').then(async (res) => res.json()).then(c => c, (error) => {
        // console.warn('Failed to load optional app config.json', error)
        // return {}
        setLoadingScreenStatus('Failed to load app config.json', true);
    }).then((config) => {
        loadAppConfig(config);
    });
}
